export default __webpack_public_path__ + "static/media/kalpna.c2c3310e.jpeg";